export default "__VITE_ASSET__BzhvN97m__"